var map = {
	"./0.png": "d977",
	"./1.png": "0ca1",
	"./10.png": "5d8c",
	"./11.png": "578b",
	"./12.png": "0cc5",
	"./13.png": "c1a1",
	"./14.png": "0566",
	"./15.png": "f954",
	"./16.png": "8709",
	"./17.png": "9d6d",
	"./18.png": "f000",
	"./2.png": "b9af",
	"./3.png": "c2e4",
	"./4.png": "1105",
	"./5.png": "9310",
	"./6.png": "2175",
	"./7.png": "34bf",
	"./8.png": "f8bf",
	"./9.png": "15b3",
	"./banner_btnl.png": "74f2",
	"./banner_btnr.png": "5a86",
	"./chan.png": "ab8e",
	"./content-1.png": "a454",
	"./content-2.png": "d53f",
	"./da.png": "1d7a",
	"./happy.png": "6d5d",
	"./hero-1.png": "8e42",
	"./hero-bg.png": "9bda",
	"./left-design-white.png": "1de5",
	"./logo-dark.png": "b68a",
	"./right-design-white.png": "600e",
	"./sponsor-4.png": "0419",
	"./tiao.png": "f45d",
	"./tuan.png": "c591",
	"./wave.png": "da3a",
	"./wei.png": "d869",
	"./wu.png": "b239",
	"./wu1.png": "85f3",
	"./wu2.png": "f490",
	"./xuan.png": "9485",
	"./zhi.png": "ac4a",
	"./zhiplay1.png": "aa2d",
	"./zhiplay2.png": "9820",
	"./zhiplay3.png": "4c12"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";